import { ItemfluxObjectType } from '@/enum/ItemfluxObjectType'
import { AloBase, getDefaultAloBase } from './AloBase'


export interface AloProfilExclusion extends AloBase {    
    ensId:number
    pfeIsActive:boolean
    pfeDesc:string
    pfeExcludedCodicStr:string    
    mrqIds:Array<number>
    flxIds:Array<number>
    nbMarque:number
    nbCodic:number
}

export const getDefaultAloProfilExclusion = ():AloProfilExclusion => {
    return {
        ...getDefaultAloBase(),
        ensId:0,
        pfeIsActive:true,
        pfeDesc:'',
        pfeExcludedCodicStr:'',
        mrqIds:[],
        flxIds:[],
        nbMarque:0,
        nbCodic:0
    }
}

export const cleanAloProfilExclusion = (pfe:AloProfilExclusion) => {
    if(!pfe) return
    if(!pfe.id) delete pfe.id
    if(!pfe.ensId) delete pfe.ensId
}